export default "__VITE_ASSET__CEs5qNd___"